import request from '../utils/request';

// 物流管理API
export const logisticsApi = {
  // 获取物流列表
  getLogisticsList: (params) => {
    return request({
      url: '/api/logistics',
      method: 'get',
      params
    });
  },

  // 获取物流详情
  getLogisticsDetail: (id) => {
    return request({
      url: `/api/logistics/${id}`,
      method: 'get'
    });
  },

  // 创建物流信息
  createLogistics: (data) => {
    return request({
      url: '/api/logistics',
      method: 'post',
      data
    });
  },

  // 更新物流信息
  updateLogistics: (id, data) => {
    return request({
      url: `/api/logistics/${id}`,
      method: 'put',
      data
    });
  },

  // 追踪物流
  trackLogistics: (trackingNumber) => {
    return request({
      url: `/api/logistics/track/${trackingNumber}`,
      method: 'get'
    });
  },

  // 获取物流服务列表
  getLogisticsServiceList: (params) => {
    return request({
      url: '/logistics/service/list',
      method: 'get',
      params: {
        name: params.name,
        code: params.code,
        page: params.page,
        pageSize: params.pageSize
      }
    });
  },

  // 创建物流服务
  createLogisticsService: (data) => {
    return request({
      url: '/logistics/service/create',
      method: 'post',
      data
    });
  },

  // 更新物流服务
  updateLogisticsService: (id, data) => {
    return request({
      url: `/logistics/service/update/${id}`,
      method: 'put',
      data
    });
  },

  // 删除物流服务
  deleteLogisticsService: (id) => {
    return request({
      url: `/logistics/service/delete/${id}`,
      method: 'delete'
    });
  },

  // 获取售后服务列表
  getAfterSalesServiceList: (params) => {
    return request({
      url: '/logistics/after-sales/list',
      method: 'get',
      params: {
        type: params.type,
        page: params.page,
        pageSize: params.pageSize
      }
    });
  },

  // 创建售后服务
  createAfterSalesService: (data) => {
    return request({
      url: '/logistics/after-sales/create',
      method: 'post',
      data
    });
  },

  // 更新售后服务
  updateAfterSalesService: (id, data) => {
    return request({
      url: `/logistics/after-sales/update/${id}`,
      method: 'put',
      data
    });
  },

  // 删除售后服务
  deleteAfterSalesService: (id) => {
    return request({
      url: `/logistics/after-sales/delete/${id}`,
      method: 'delete'
    });
  },

  // 获取运费服务列表
  getFreightServiceList: (params) => {
    return request({
      url: '/logistics/freight/list',
      method: 'get',
      params: {
        name: params.name,
        page: params.page,
        pageSize: params.pageSize
      }
    });
  },

  // 创建运费服务
  createFreightService: (data) => {
    return request({
      url: '/logistics/freight/create',
      method: 'post',
      data
    });
  },

  // 更新运费服务
  updateFreightService: (id, data) => {
    return request({
      url: `/logistics/freight/update/${id}`,
      method: 'put',
      data
    });
  },

  // 删除运费服务
  deleteFreightService: (id) => {
    return request({
      url: `/logistics/freight/delete/${id}`,
      method: 'delete'
    });
  }
}; 